import { Anchor, Breadcrumbs, Text } from '@mantine/core';
import { useTranslate } from '@tolgee/react';
import type { ReactNode } from 'react';
import { Link, useMatches, type UIMatch } from 'react-router-dom';

type BreadcrumbHandle = {
  breadcrumbKey?: string;
  breadcrumb?: ((match: UIMatch) => ReactNode) | ReactNode;
};

const HeaderBreadcrumbs = () => {
  const { t } = useTranslate();
  const matches = useMatches();

  const breadcrumbMatches = matches.filter(match => {
    const handle = match.handle as BreadcrumbHandle | undefined;
    return Boolean(handle?.breadcrumbKey || handle?.breadcrumb);
  });

  if (breadcrumbMatches.length === 0) {
    return null;
  }

  const items = breadcrumbMatches.map((match, index, array) => {
    const handle = match.handle as BreadcrumbHandle | undefined;
    const crumb = handle?.breadcrumbKey
      ? t(handle.breadcrumbKey)
      : typeof handle?.breadcrumb === 'function'
        ? handle.breadcrumb(match)
        : handle?.breadcrumb;
    const isLast = index === array.length - 1;

    if (isLast) {
      return (
        <Text key={match.pathname} aria-current="page" c="dimmed">
          {crumb}
        </Text>
      );
    }

    return (
      <Anchor key={match.pathname} component={Link} to={match.pathname} underline="never">
        {crumb}
      </Anchor>
    );
  });

  return (
    <nav aria-label={t('nav.breadcrumb')}>
      <Breadcrumbs separator="›">{items}</Breadcrumbs>
    </nav>
  );
};

export default HeaderBreadcrumbs;
